import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { getAccessTokenApi } from 'api/auth';
import { BASE_PATH_SERVER } from 'api/config';

/**
 * Select de equipos (ascensores y areas) de un cliente, POR ID.
 *
 * Existe aparte de components/selects/AscensorInlineSelect porque aquel trabaja
 * por NOMBRE —sirve al campo legacy de texto libre— y la creacion de tareas
 * necesita el id para armar la relacion N:M del equipo.
 *
 * Props:
 *   idCliente — cliente de la ODT; sin el no se consulta nada.
 *   value — id del equipo elegido, o null.
 *   onChange(id|null)
 *   disabled
 */
export default function EquipoAscensorSelect({ idCliente, value, onChange, disabled = false }) {
  const [opciones, setOpciones] = useState([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    let vigente = true;
    if (!idCliente) {
      setOpciones([]);
      return () => {
        vigente = false;
      };
    }
    const cargar = async () => {
      setCargando(true);
      try {
        const res = await fetch(`${BASE_PATH_SERVER}clientes/${idCliente}/ascensores`, {
          headers: { Authorization: getAccessTokenApi() },
        });
        const data = await res.json();
        const lista = Array.isArray(data)
          ? data
          : Array.isArray(data?.ascensores)
          ? data.ascensores
          : [];
        if (!vigente) return;
        setOpciones(lista.map((a) => ({ value: a.id, label: a.nombre })));
      } catch {
        // Silencioso: el select queda vacio y el equipo es opcional.
        if (vigente) setOpciones([]);
      } finally {
        if (vigente) setCargando(false);
      }
    };
    cargar();
    return () => {
      vigente = false;
    };
  }, [idCliente]);

  return (
    <Select
      allowClear
      showSearch
      optionFilterProp="label"
      placeholder="Sin equipo"
      style={{ width: '100%' }}
      disabled={disabled}
      loading={cargando}
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? null)}
      options={opciones}
    />
  );
}
